<template>
  <div class="wrapper">
    <side-bar>
      <template slot="links">
        <sidebar-link to="/profile" name="User Profile" icon="user"/>
        <sidebar-link to="/request-license" name="Request Licenses" icon="certificate"/>
        <sidebar-link v-if="!isMember" to="/users" name="User Management" icon="users"/>
        <sidebar-link v-if="!isMember" to="/licenses" name="License Management" icon="table"/>
        <sidebar-link to="/downloads" name="Downloads" icon="download" :divider-after="!canViewReports"/>
        <sidebar-link v-if="canViewReports" to="/reports" name="Reports" icon="table-list" divider-after/>
        <sidebar-link v-if="usesDeviceLink" to="/device-link/reports" name="Device Link Reports" icon="archive"/>
        <sidebar-link v-if="usesMobile" to="/mobile-devices/" name="Mobile Devices" icon="mobile"/>
        <sidebar-link v-if="usesErasure" to="/erased/computers" name="Erased Computers" icon="desktop"/>
        <sidebar-link v-if="usesErasure" to="/erased/disks" name="Erased Disks" icon="hdd"/>
        <sidebar-link v-if="usesVerification" to="/verified/computers" name="Verified Computers" icon="desktop"/>
        <sidebar-link v-if="usesVerification" to="/verified/disks" name="Verified Disks" icon="hdd"/>
        <sidebar-link v-if="usesEnrollment" to="/enrollments" name="Enrollments" icon="lock"/>
      </template>
      <mobile-menu>
        <li class="nav-item">
          <logout-button />
        </li>
        <li class="divider"></li>
      </mobile-menu>
    </side-bar>
    <div class="main-panel" :class="{ 'with-right-sidebar': showRightSidebar }">
      <top-navbar></top-navbar>
      <dashboard-content @click.native="toggleSidebar"></dashboard-content>
      <content-footer></content-footer>
    </div>
    <right-side-bar v-if="showRightSidebar">
      <tasks-table />
    </right-side-bar>
  </div>
</template>

<script>
import TopNavbar from "./TopNavbar.vue";
import ContentFooter from "./ContentFooter.vue";
import DashboardContent from "./Content.vue";
import MobileMenu from "./MobileMenu";
import LogoutButton from "../../components/Buttons/LogoutButton.vue";
import RightSideBar from "../../components/SidebarPlugin/RightSideBar.vue";
import TasksTable from "../../components/Tables/TasksTable.vue";
import { mapGetters } from 'vuex';

export default {
  components: {
    TopNavbar,
    ContentFooter,
    DashboardContent,
    MobileMenu,
    LogoutButton,
    RightSideBar,
    TasksTable
  },
  created() {
    this.handleUserHome();
  },
  methods: {
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    },
    async handleUserHome() {
      if (!this.user) {
        await this.$store.cache.dispatch('user/fetchMe');
      }

      if (this.$route.path == "/") {
        let homePage = "/profile";
        if (this.isSuperUser || this.isStaffUser) {
          homePage = "/licenses";
        }
        this.$router.push(homePage);
      }
    }
  },
  computed: {
    ...mapGetters('user', ['user', 'isSuperUser', 'isStaffUser', 'isMember']),
    ...mapGetters('dashboard', ['showRightSidebar']),
    usesDeviceLink() {
      return this.user !== null && this.user.group.uses_device_link
    },
    usesMobile() {
      return this.user !== null && this.user.group.uses_mobile
    },
    usesErasure() {
      return this.user !== null && this.user.group.uses_erasure
    },
    usesVerification() {
      return this.user !== null && this.user.group.uses_verification
    },
    usesEnrollment() {
      return this.user !== null && this.user.group.uses_enrollment
    },
    canViewReports() {
      return this.isSuperUser || this.isStaffUser
    },
  },
  watch: {
    '$route': {
      handler() {
        this.handleUserHome();
      }
    }
  }
};
</script>
